import React from 'react';
import IntegrationCard from "../IntegrationCard/IntegrationCard";
import financialCentsLogoUrl from "./financial-cents-logo.png";
import { integrationModel } from "../../../models";
import { useIoContext, useStoreActions } from "../../../contexts";
import { useHistory } from 'react-router';
import { routes } from "../../../constants";
export default function FinancialCentsCard(props) {
  const {
    integration
  } = props;
  const {
    api
  } = useStoreActions();
  const {
    changeLocation
  } = useIoContext();
  const history = useHistory();
  const isLinked = integrationModel.isLinked(integration);
  const buttonProps = isLinked ? {
    'data-testid': 'financial-cents-manage-connection',
    children: 'Manage connection',
    onClick: () => history.push(routes.financialCentsSetup)
  } : {
    'data-testid': 'financial-cents-connect',
    children: 'Connect',
    onClick: async () => {
      const redirectUrl = "".concat(window.location.origin).concat(routes.financialCentsSetup);
      const linkUrl = await api.financialCents.connect(redirectUrl);
      const connectUrl = new URL(linkUrl);
      connectUrl.searchParams.append('host', window.location.host);
      changeLocation(connectUrl.toString());
    }
  };
  return /*#__PURE__*/React.createElement(IntegrationCard, {
    "data-testid": "financial-cents-card",
    title: "Financial Cents",
    subTitle: "Connect your account for efficient workflows between your team and your clients",
    mainAction: /*#__PURE__*/React.createElement(IntegrationCard.MainActionButton, buttonProps),
    icon: /*#__PURE__*/React.createElement(IntegrationCard.LogoImg, {
      alt: "financial cents logo",
      src: financialCentsLogoUrl
    }),
    disclaimer: "* Requires the Scale plan in Financial Cents"
  });
}